import { createApiClient } from '@akillidernek/api-client'
import { getAccessToken, setAccessToken } from './auth-store'
import { getTenantSlug, setTenantSlug } from './tenant-store'

/**
 * Tek istemci örneği. Aynı origin'e gider: Vite geliştirmede `/api` ve
 * `/health` isteklerini API'ye vekiller, üretimde ikisi de aynı alan adı
 * altındadır.
 */
export const api = createApiClient({
  getTenantSlug,
  getAccessToken,
  onUnauthenticated: () => {
    // Oturum düştü: dernek seçimi de anlamsızlaşır.
    setAccessToken(null)
    setTenantSlug(null)
  },
})

/**
 * Sayfa açılışında oturumu geri kurar.
 *
 * Yenileme jetonu httpOnly çerezde olduğu için JavaScript onu göremez; tek
 * yol sunucuya sormaktır. 401 dönmesi normal: kullanıcı henüz giriş yapmamış.
 */
export async function bootstrapSession(): Promise<boolean> {
  try {
    const { data } = await api.POST('/api/v1/auth/refresh')
    if (data?.access_token) {
      setAccessToken(data.access_token)
      return true
    }
  } catch {
    // Oturum yok ya da süresi dolmuş.
  }
  return false
}
